import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2'


import { fetchConToken } from '../../../helpers/fetch';
import { clientLoadFinishRedes } from "../../../actions/client";

export default function Redes() {
  const dispatch = useDispatch();
  const {folio} = useSelector(state => state.client);
    
    useEffect(() => {
        Swal.fire({
            confirmButtonText: '<a style="text-decoration: none; color:fff;" href="https://www.tiktok.com/@skyfest.mx" target="_blank">Tik Tok</a>',
            confirmButtonColor: '#000',
            icon: 'info',
            html: 'Para estar al tanto de toda la información de tu evento y poder ganar barras libres, botellas, skykits y mucho más, síguenos en Instagram y Tik Tok',
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    confirmButtonText: '<a style="text-decoration: none; color:fff;" href="https://instagram.com/skyfestmx" target="_blank">Instagram</a>',
                    confirmButtonColor: '#E1306C',
                    icon: 'info',
                    html: 'Para estar al tanto de toda la información de tu evento y poder ganar barras libres, botellas, skykits y mucho más, síguenos en Instagram y Tik Tok',
                    allowOutsideClick: false,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      dispatch( clientLoadFinishRedes() );
                      fetchConToken(`redes/${folio}`);
                    }
                  })
            }
          })
    }, [])
    
  return (
    <></>
  )
}
